<template>
  <img v-bind="$attrs" :src="currentSrc" :alt="alt" data-theme-aware="true" :data-theme-icon="iconConfigString" />
</template>

<script setup>
import { computed } from 'vue';
import { themeIconMap } from '@/javascript/themeIconMap';

const props = defineProps({
  icon: {
    type: String,
    required: true,
    validator: (value) => {
      return !!themeIconMap[value];
    },
  },
  alt: {
    type: String,
    default: '',
  },
});

defineOptions({
  inheritAttrs: false,
  name: 'ThemeImage',
});

const iconConfig = computed(() => themeIconMap[props.icon]);
const iconConfigString = computed(() => JSON.stringify(iconConfig.value));

const currentSrc = computed(() => {
  return iconConfig?.value?.darkIcon;
});
</script>
